import axios from "axios";
import ApiUrl from "../../constant/endpoint";
import {
  ADD_CATEGORY_REQUEST,
  ADD_CATEGORY_SUCCESS,
  ADD_CATEGORY_FAILURE,
  UPDATE_CATEGORY_REQUEST,
  UPDATE_CATEGORY_SUCCESS,
  UPDATE_CATEGORY_FAILURE,
  DELETE_CATEGORY_REQUEST,
  DELETE_CATEGORY_SUCCESS,
  DELETE_CATEGORY_FAILURE,
  GET_CATEGORY_REQUEST,
  GET_CATEGORY_SUCCESS,
  GET_CATEGORY_FAILURE,
} from "../constants/categoryConstant";

export const addCategoryAction = (categoryData) => async (dispatch) => {
  try {
    dispatch({ type: ADD_CATEGORY_REQUEST });
    console.log(categoryData);

    const url = ApiUrl.createCategory;
    const { data } = await axios.post(url, categoryData);

    if (data.success) {
      dispatch({
        type: ADD_CATEGORY_SUCCESS,
        payload: data,
      });
      return true;
    } else {
      dispatch({
        type: ADD_CATEGORY_FAILURE,
        payload: data,
      });
      return false;
    }
  } catch (error) {
    console.error("Error", error);

    dispatch({
      type: ADD_CATEGORY_FAILURE,
      payload: error.response ? error.response.data : "Unknown error",
    });
    return false;
  }
};

export const updateCategoryAction =
  (categoryId, categoryData) => async (dispatch) => {
    try {
      dispatch({ type: UPDATE_CATEGORY_REQUEST });
      const URL = `${ApiUrl.updateCategory}?categoryId=${categoryId}`;
      const { data } = await axios.put(URL, categoryData);
      if (data.success) {
        dispatch({
          type: UPDATE_CATEGORY_SUCCESS,
          payload: data,
        });
        return true;
      }
    } catch (error) {
      console.log(error.response.data);
      console.log(error.response.status);
      console.log(error.response.headers);
      if (error.response.status === 500) {
        dispatch({
          type: UPDATE_CATEGORY_FAILURE,
          payload: "Internal Server Error",
        });
      } else {
        dispatch({
          type: UPDATE_CATEGORY_FAILURE,
          payload: error.response.data,
        });
      }
    }
  };

export const deleteCategory = (categoryId) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_CATEGORY_REQUEST });
    const URL = `${ApiUrl.deleteCategory}?categoryId=${categoryId}`;

    const { data } = await axios.delete(URL);
    console.log("response", data);
    if (data.success) {
      dispatch({
        type: DELETE_CATEGORY_SUCCESS,
        payload: data.success,
      });
      console.log("response", data);
      return true;
    }
    return false;
  } catch (error) {
    dispatch({
      type: DELETE_CATEGORY_FAILURE,
      payload: error.response.data,
    });
  }
};

export const getCategoryAction = (categoryId) => async (dispatch) => {
  console.log("categoryId", categoryId);
  try {
    dispatch({ type: GET_CATEGORY_REQUEST });
    const URL = `${ApiUrl.getCategoryById}?categoryId=${categoryId}`;
    const { data } = await axios.get(URL);
    if (data.success) {
      dispatch({
        type: GET_CATEGORY_SUCCESS,
        payload: data.response,
      });
      return data;
    }
  } catch (error) {
    console.log(error.response.data);
    console.log(error.response.status);
    console.log(error.response.headers);
    if (error.response.status === 500) {
      dispatch({
        type: GET_CATEGORY_FAILURE,
        payload: "Internal Server Error",
      });
    } else {
      dispatch({
        type: GET_CATEGORY_FAILURE,
        payload: error.response.data,
      });
    }
  }
};
